import React from 'react'
import { useAgTechQuery } from '@agtech/core/data/queries/AgTechDataQueries'
import { AgTechUserProfile, AgTechUserProfileRoute } from '@agtech/data/users/AgTechUserProfileData'
import { UserDataGetMyProfileQuery } from '@agtech/data/users/AgTechUserProfileQueries'
import { useUserDataUpdateProfileAction } from '@agtech/data/users/AgTechUserProfileActions'
import { AgTechButton, AgTechButtonProps, AgTechClickEventHandler } from '../../../components/Buttons/AgTechButtons'
import { AgTechFormReadOnlyTextControl } from '../../../components/Forms/Controls/AgTechFormReadOnlyTextControl'
import { AgTechFormTextControl } from '../../../components/Forms/Controls/AgTechFormTextControl'
import AgTechFormBody from '../../../components/Forms/Layout/AgTechFormBody'
import { AgTechFormRow } from '../../../components/Forms/Layout/AgTechFormRow'
import AgTechFormDialog from '../../../components/Portals/Dialogs/AgTechFormDialog'

export type MyProfileEditDialogProps = {
    route: AgTechUserProfileRoute
}

const MyProfileEditDialog = (props: MyProfileEditDialogProps) => {
    const dialogQuery = useAgTechQuery({
        query: UserDataGetMyProfileQuery,
        queryContext: { route: props.route }
    });

    const dialogAction = useUserDataUpdateProfileAction(props.route);

    return (
        <AgTechFormDialog
            width={500}
            dialogData={{
                query: dialogQuery,
                getDialogData: (profile): AgTechUserProfile => ({
                    ...profile,
                    phoneNumber: profile.phoneNumber ?? ''
                })
            }}
            dialogAction={{
                action: dialogAction,
                getActionData: d => d
            }}
            structure={() => ({
                header: 'Update My Info',
                submitButtonText: 'Save'
            })}
        >
            {(formContext) => (
                <AgTechFormBody>
                    <div id='my-profile-name'>
                        <AgTechFormRow>
                            <AgTechFormTextControl
                                entityType={formContext.entity}
                                caption='First Name'
                                required={true}
                                focused={true}
                                value={user => user.firstName}
                                onControlValueChanged={async (e, val) => ({ ...e, firstName: val })}
                            />
                            <AgTechFormTextControl
                                entityType={formContext.entity}
                                caption='Last Name'
                                required={true}
                                value={user => user.lastName}
                                onControlValueChanged={async (e, val) => ({ ...e, lastName: val })}
                            />
                        </AgTechFormRow>
                    </div>
                    <div id='my-profile-contact'>
                        <AgTechFormRow>
                            <AgTechFormReadOnlyTextControl
                                entityType={formContext.entity}
                                caption='Email Address'
                                value={user => user.email}
                            />
                            <AgTechFormTextControl
                                entityType={formContext.entity}
                                caption='Phone Number'
                                value={user => user.phoneNumber}
                                onControlValueChanged={async (e, val) => ({ ...e, phoneNumber: val })}
                            />
                        </AgTechFormRow>
                    </div>
                </AgTechFormBody>
            )}
        </AgTechFormDialog>
    )
}

MyProfileEditDialog.Open = (e: AgTechClickEventHandler, props: MyProfileEditDialogProps) => e.dialogs.openDialog({
    dialog: () => <MyProfileEditDialog {...props} />
})

MyProfileEditDialog.Button = (props: MyProfileEditDialogProps & AgTechButtonProps) => (
    <AgTechButton
        text='Update My Info'
        icon='fas fa-edit'
        {...props}
        action={e => MyProfileEditDialog.Open(e, props)}
    />
)

export default MyProfileEditDialog
